<template src="./TaskList/TaskList.html"></template>
<script>
import Punctuality from '@/widgets/Punctuality'
import Time from '@/widgets/Time'
import ConsignmentDetails from './ConsignmentDetails'
import MerchantPickup from './MerchantPickup'
import MerchantReturn from './MerchantReturn'
import TerminalParcels from './TerminalParcels'
import LockerDetails from './LockerDetails'

export default {
    name: 'TaskList',
    components: {
        Punctuality,
        ConsignmentDetails,
        MerchantPickup,
        MerchantReturn,
        TerminalParcels,
        Time,
        LockerDetails,
    },
    props: {
        tasks: Array,
        filterQuery: String,
        onTasksSelectedChange: Function,
        selectedTaskIds: Array,
        onTaskExpanded: Function,
        expandedTaskId: String,
        returnPallets: Array,
        pickupHistory: Object,
    },
    watch: {
        expandedTaskId(newVal) {
            if (newVal) {
                this.moveTaskItemIntoView(newVal)
            }
        },
    },
    methods: {
        routeTypeIsDistributionOrMerchant() {
            return (
                this.tasks.some((e) => e.type === 'DELIVERY') ||
                this.tasks.some((e) => e.type === 'RETURN') ||
                this.tasks.some((e) => e.type === 'MERCHANT_RETURN') ||
                this.tasks.some((e) => e.type === 'PICKUP')
            )
        },
        moveTaskItemIntoView(taskId) {
            const taskListItem = this.$refs.taskList.querySelector(`[data-id="${taskId}"`)
            if (!taskListItem) {
                return
            }

            // defer to after opening the task item
            setTimeout(() => {
                const { parentNode: scrollable } = this.$refs.taskList

                const upperBound = scrollable.scrollTop
                const lowerBound = scrollable.clientHeight + scrollable.scrollTop

                const underUpperBound = taskListItem.offsetTop < upperBound
                const overLowerBound =
                    taskListItem.offsetTop + taskListItem.clientHeight > lowerBound

                if (underUpperBound || overLowerBound) {
                    scrollable.scrollTop = taskListItem.offsetTop
                }
            }, 0)
        },
        onTaskExpand(taskId) {
            this.$props.onTaskExpanded(taskId)
        },
        onTaskSelected(taskId) {
            if (this.selectedTaskIds.includes(taskId)) {
                this.onTasksSelectedChange(this.selectedTaskIds.filter((id) => id !== taskId))
            } else {
                this.onTasksSelectedChange([...this.selectedTaskIds, taskId])
            }
        },
        selectAllTasks(event) {
            if (event.target.checked) {
                const canActOnTask = (task) =>
                    task.cancelable || task.splittable || task.completable
                const newSelectedTasks = this.tasks
                    .filter((task) => task.type !== 'TERMINAL')
                    .filter(canActOnTask)
                    .map((task) => task.id)
                this.onTasksSelectedChange(newSelectedTasks)
            } else {
                this.onTasksSelectedChange([])
            }
        },
        isFilteredOut(filterQuery, task) {
            if (filterQuery.trim().length === 0) {
                return false
            }
            return (
                filterQuery
                    .split(' ')
                    .filter((word) => task.searchWords.includes(word.toLowerCase())).length === 0
            )
        },
    },
}
</script>
<style lang="scss" scoped src="./TaskList/TaskList.scss"></style>
